define.alias("ember-math-helpers/helpers/sqrt", "settings/helpers/sqrt");